import { render, staticRenderFns } from "./InjuryTypeChart.vue?vue&type=template&id=bfbf3d1e"
import script from "./InjuryTypeChart.vue?vue&type=script&lang=js"
export * from "./InjuryTypeChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports